// React
import React from 'react';
// Styles
import useStyles from './NivelatTutorialBox.styles';
import CustomButton from '../common/buttons/custom-button/CustomButton';
import PartnersService from '../../services/partners-service';

// Componentes

const NivelatTutorialBox = ({
  profile,
  covidTitle,
  covidDescription,
  covidMoreInfo,
  covidTipsButton,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.containerBox}>
        <div className={classes.titles}>{covidTitle}</div>
        <div className={classes.Subtitles}>{covidDescription}</div>
        <div className={classes.SubContent}>{covidMoreInfo}</div>
        <div className={classes.buttonContainer}>
          <CustomButton
            color='secondary'
            variant='contained'
            className={classes.goPortal}
            text={covidTipsButton}
            onClick={() => {
              window.open(PartnersService.nivelatAuth(profile), '_blank');
              return;
            }}
          ></CustomButton>
        </div>
      </div>
    </div>
  );
};

NivelatTutorialBox.defaultProps = {
  classes: {},
};
export default NivelatTutorialBox;
